import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

// Constants
const DEFAULT_HEIGHT = "2.3rem";
const ICON_MARGIN = "0.7rem";
const INPUT_ICON_PADDING = "2.8rem";

// Exports
export interface InputWithIconsProps {
  childLeft?: boolean;
  childRight?: boolean;
  disabled?: boolean;
  error?: boolean;
}
export const InputWithIcons = styled.div<InputWithIconsProps>`
  align-items: center;
  box-sizing: border-box;
  color: ${props => {
    if (props.error) return colors.redD;
    if (props.disabled) return colors.grayA;
    return colors.gray6;
  }};
  border-color: ${props => {
    if (props.error) return colors.redD;
    if (props.disabled) return colors.grayF;
    return undefined;
  }};
  display: inline-flex;
  height: ${DEFAULT_HEIGHT};
  justify-content: center;
  position: relative;

  > input {
    padding-left: ${props => props.childLeft && INPUT_ICON_PADDING};
    padding-right: ${props => props.childRight && INPUT_ICON_PADDING};
    width: 100%;

    &:focus + button {
      border-color: ${colors.blueA};
      border-left-color: transparent;
    }
  }

  > svg,
  > button {
    color: ${props => props.error && colors.redLight};
    position: absolute;
    padding: ${props =>
      props.childLeft || props.childRight ? `0 ${ICON_MARGIN}` : "0"};

    &:first-child {
      left: ${props => props.childLeft && "0"};
    }
    &:last-child {
      right: ${props => props.childRight && "0"};
    }
  }
  > button {
    border-left-color: transparent;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
